'use client';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const PixelAudienceObservability = () => {
	const pathname = usePathname();
	useEffect(() => {
		const script = document.createElement('script');
		script.innerHTML = `!function(a,e,d,m,t){
      a.adm={}; a.adm.pixid=154764;
      var o=e.getElementsByTagName("head")[0], c=e.createElement("script");
      a.adm.json="https://ps.l.liftdsp.com/547bb86a-0c5b-4b9f-b2fd-b3b23c49a9fe.json";
      a.adm.pixurl="https://pool.admedo.com";
      c.src="https://pj.l.liftdsp.com/admtracker.lib.min.js";
      c.async=!0; o.appendChild(c);
    }(window,document);`;
		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, []);

	useEffect(() => {
		if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'prod') {
			return;
		}

		if (!(window as any).fbq) {
			const script = document.createElement('script');
			script.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '1023913816516272');
			`;
			document.head.appendChild(script);
		}
	}, []);

	useEffect(() => {
		if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'prod') {
			console.log('[FB Pixel] PageView for path:', pathname);
			return;
		}

		if (typeof window.fbq === 'function') {
			window.fbq('track', 'PageView');
		}
	}, [pathname]);

	return (
		<noscript>
			<img
				height="1"
				width="1"
				style={{ display: 'none' }}
				src="https://pool.admedo.com/pixel?id=154764&t=img"
				alt=""
			/>
		</noscript>
	);
};

export default PixelAudienceObservability;
